module.exports = new __parcel__URL__("default-avatar.8d6e3095.svg").toString();